/* eslint-disable react-hooks/exhaustive-deps */
import { ErrorMessage, Field, FormikProvider, useFormik, } from "formik";
import *  as  HERBUI from "react-bootstrap";
import * as Yup from 'yup'
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import { useDispatch } from "react-redux";
import Select from "react-select";
import Swal from "sweetalert2";
import { useEffect,useState } from "react";
import moment from "moment/moment";
import { CommonAjaxGetRequestWithOutParamsWithOutAuthorization, CommonAjaxPostRequest } from "../Api/CommonAjaxUtils";
import { fileupload } from "../components/FileUpload";
import { BASE_URL, DropdownList, OTpforServiceAssociation, ServiceAssociation } from "../Api/APIURLS";
import { allowNumbersOnly } from "../components/Functions";
import Header from "./Header";
const ServiceAssociationMain = () => {
    const [departmentlist, setDepartmentlist] = useState([])
    const [otpflag, setOtpflag] = useState(false);
    const [securitykey,setSecuritykey]=useState("")
    const [name, setName] = useState("Get OTP")
    const initialValues = {
        nameofserviceassociation: "",
        nameofdepartment: "",
        totalnoofempleindepartme: "",
        noofempenrolledinasso: "",
        percenofempenrolled: "",
        bankaccountnumber: "",
        ifsccode: "",
        bylaws: "",
        bylawsfileupload: "",
        annualaudited: "",
        annualauditedfileupload: "",
        electiondeclaration: "",
        electiondeclarationfileupload: "",
        listofofficebeareres: "",
        listofofficebeareresfileupload: "",
        alreadyregisterthengodate: "",
        officialaddressofserviceass: "",
        officialmobilenumber: "",
        gotype: "",
        gonumber: "",
        godate: "",
        cfmsid:"",
        username:'',
        mobilenumber:"",
        enteredOtp:"",
        rigistrationfile:"",
        appointmentofficerfile:"",
        electionnotificationfile:""
    }
    const validationSchema = Yup.object({
        nameofserviceassociation: Yup.string().required('Mandatory!'),
        totalnoofempleindepartme: Yup.string().required('Mandatory!'),
        nameofdepartment: Yup.string().required('Mandatory!'),
        noofempenrolledinasso: Yup.string().required('Mandatory!'),
        percenofempenrolled: Yup.string().required('Mandatory!'),
        bankaccountnumber: Yup.string().required('Mandatory!'),
        ifsccode: Yup.string().required('Mandatory!').matches("^[A-Z]{4}0[A-Z0-9]{6}$", "Enter valid IFSC Code"),
     
        bylawsfileupload:Yup.string().required('Mandatory!'),
        annualauditedfileupload:Yup.string().required('Mandatory!'),
        electiondeclarationfileupload:Yup.string().required('Mandatory!'),
        listofofficebeareresfileupload:Yup.string().required('Mandatory!'),
        rigistrationfile:Yup.string().required('Mandatory!'),
        appointmentofficerfile:Yup.string().required('Mandatory!'),
        electionnotificationfile:Yup.string().required('Mandatory!'),
        alreadyregisterthengodate: Yup.string().required('Mandatory!'),
        gotype: Yup.string().when("alreadyregisterthengodate", {
            is: (val) => val === "yes",
            then: Yup.string().required("Mandatory!")
        }),
        gonumber: Yup.string().when("alreadyregisterthengodate", {
            is: (val) => val === "yes",
            then: Yup.string().required("Mandatory!")
        }),
        godate: Yup.string().when("alreadyregisterthengodate", {
            is: (val) => val === "yes",
            then: Yup.string().required("Mandatory!")
        }),
        officialaddressofserviceass: Yup.string().required('Mandatory!'),
        officialmobilenumber: Yup.string().required('Mandatory!').matches(/^[6-9]\d{9}$/, "enter valid mobile number"),
        mobilenumber: Yup.string().required('Mandatory!'),
        username: Yup.string().required('Mandatory!'),
        cfmsid: Yup.string().required('Mandatory!'),

    })
    const dispatch = useDispatch()
    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: (values) => {
           
            if (otpflag === false) {
                let payload={
                    "cfmsId":formik.values.cfmsid
                }
                CommonAjaxPostRequest(OTpforServiceAssociation,payload,dispatch).then(res=>{
                    if(res)
                    {
                        if (res.SCODE === "01") {
                            Swal.fire({ text: res.SDESC, icon: 'success', confirmButtonColor: '#3085d6', confirmButtonText: "Ok", })
                            setOtpflag(true)
                            setName("Submit")
                          
                            setSecuritykey(res.SecurityKey)
                           
                        }
                        else if (res.SCODE === "02") {
                            Swal.fire({ text: res.SDESC, icon: 'warning', confirmButtonColor: '#3085d6', });
                        }

                    }
                    
                    
                })
                
            }
            if(otpflag===true){
                if(formik.values.enteredOtp==="")

                {
                    Swal.fire({ text:"Please Enter OTP", icon: 'warning', confirmButtonColor: '#3085d6', });

                }
                else{
                    postData(values)
                    

                }
               

            }
           
        },
        enableReinitialize: true
    })
    function postData(values) {
        let godate;
        let gonumber;
        let gotype;
        if (formik.values.alreadyregisterthengodate === "yes" && formik.values.alreadyregisterthengodate !== undefined && formik.values.alreadyregisterthengodate !== null && formik.values.alreadyregisterthengodate !== "") {
            godate = moment(formik.values.godate).format("DD-MM-YYYY")
            gonumber = formik.values.gonumber
            gotype = formik.values.gotype
        }

        let bylawfile= formik.values.bylawsfileupload
        let auditfile= formik.values.annualauditedfileupload
        let electionfile = formik.values.electiondeclarationfileupload
        let officefile= formik.values.listofofficebeareresfileupload
        let registeredfiles=formik.values.rigistrationfile
        let appointmentofficerfiles=formik.values.appointmentofficerfile
        let electionnotificationfile=formik.values.electionnotificationfile
        let params = {
            "serviceName": formik.values.nameofserviceassociation,
            "secDeptCode": formik.values.nameofdepartment,
            "noOfEmps": formik.values.totalnoofempleindepartme,
            "enrolledMemp": formik.values.noofempenrolledinasso,
            "enrolledPercentage": (formik.values.percenofempenrolled),
            "byLawsSubFile": bylawfile,
            "annualAuditedSubFile": auditfile,
            "bankNo": formik.values.bankaccountnumber,
            "ifscCode": formik.values.ifsccode,
            "electionDeclarationSubFile": electionfile,
            "officeBearersSubFile": officefile,
            "registeredGoStatus":formik.values.alreadyregisterthengodate,
            "goType": gotype,
            "goNo": gonumber,
            "godDate": godate,
            "officeAddress": formik.values.officialaddressofserviceass,
            "offMobileNo": formik.values.officialmobilenumber,
            "otp":formik.values.enteredOtp,
            "cfmsId":formik.values.cfmsid,
            "secureKey":securitykey,
            "registrationCertificate":registeredfiles,
            "appointmentOfElectionOfficerFile":appointmentofficerfiles,
            "electionNotificationFile":electionnotificationfile
        }
        CommonAjaxPostRequest(ServiceAssociation, params, dispatch).then((res) => {
            if (res !== undefined && res !== null && res !== "") {
                if (res.SCODE === "01") {
                    Swal.fire({ text: res.SDESC, icon: 'success', confirmButtonColor: '#3085d6', }).then(
                        function () {
                            // history.push("/login")
                            window.location.href = "/login"
                        }
                    );
                }
                else if (res.SCODE === "02") {
                    Swal.fire({ text: res.SDESC, icon: 'warning', confirmButtonColor: '#3085d6', })
                }
            }
        })
    }
    const handlegodate = (e) => {
        formik.setFieldValue("godate", e)
    }
    const handledotype = (e) => {
        formik.setFieldValue("gotype", e.target.value)
        formik.setFieldValue("gonumber", "")
        formik.setFieldValue("godate", "")
    }
    useEffect(() => {
        CommonAjaxGetRequestWithOutParamsWithOutAuthorization(DropdownList, dispatch).then((res) => {
            if (res !== undefined && res !== null && res !== "") {
                setDepartmentlist(res)
            }
        })
    }, [])
   
    const handleEmploytotal = (e) => {
        formik.setFieldValue("totalnoofempleindepartme", e.target.value)
        formik.setFieldValue("noofempenrolledinasso", "")
        formik.setFieldValue("percenofempenrolled", "")
    }
    const handleenrollmemauto = (e) => {
        let msg = " First Enter Total no. of Employees in the Department"
      
        if (formik.values.totalnoofempleindepartme !== undefined && formik.values.totalnoofempleindepartme !== null && formik.values.totalnoofempleindepartme !== "") {
            if (parseInt(formik.values.totalnoofempleindepartme) >= parseInt(e.target.value)) {
                formik.setFieldValue("noofempenrolledinasso", e.target.value)
                let totalEMP = formik.values.totalnoofempleindepartme
                let noofEMP = e.target.value
                let value = (noofEMP / totalEMP) * 100
                if (value >= 25) {
                    formik.setFieldValue("percenofempenrolled", (value).toFixed(2))
                }
                else {
                    Swal.fire({ text: "Percentage of Members Enrolled Should be Above 25%", icon: 'warning', confirmButtonColor: '#3085d6', })
                    formik.setFieldValue("percenofempenrolled", "")
                    formik.setFieldValue("noofempenrolledinasso", '')
                }
            }
            else {
                Swal.fire({ text: "No. of Enrolled Members in the Association should be less than Total no. of Employees in the Department ", icon: 'warning', confirmButtonColor: '#3085d6', })
                formik.setFieldValue("noofempenrolledinasso", "")
                formik.setFieldValue("percenofempenrolled", "")
            }


        }
        else {
            Swal.fire({ text: msg, icon: 'warning', confirmButtonColor: '#3085d6', })
            formik.setFieldValue("noofempenrolledinasso", "")
        }


    }
   
    const getDetails = (e) => {
        if (e.target.value !== '') {
            CommonAjaxGetRequestWithOutParamsWithOutAuthorization(BASE_URL + "login/forgotpassworddetailsverification/" + e.target.value,dispatch).then(res => {
                if (res.SCODE === "01") {
                    
                    formik.setFieldValue("username",res.name)
                    formik.setFieldValue("mobilenumber",res.mobileNo)

                }

                else if (res.SCODE === "02") {
                    Swal.fire({ text: res.SDESC, icon: 'warning', confirmButtonColor: '#3085d6', });
                }
            })
        }
        else {
            Swal.fire({ text: "Cfms Id Should Not be Empty", icon: 'warning', confirmButtonColor: '#3085d6', });
        }
    }
    return (
        <>
         <Header />
            <div className="main_section servicesregistration pb-4">
            <HERBUI.Container className="mt-5">
                <HERBUI.Row>
                    <HERBUI.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="page-titlespacing">
                        <div className="inner-herbpage-service-title1">
                        <h1>Service Associations Registration  Form</h1>
                        </div>
                    </HERBUI.Col>
                </HERBUI.Row>
           </HERBUI.Container>
           <HERBUI.Container className=" bg-white">
                    <FormikProvider value={formik}>
                        <form onSubmit={formik.handleSubmit} autoComplete='on' >
                          
                                    <HERBUI.Row className="pt-3 m-0">
                                        <HERBUI.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className="mb-3">
                                            <label className="mb-2">Name of Service Association :<span className="text-danger">*</span> </label>
                                            <Field type="text" name="nameofserviceassociation" className="form-control" autoComplete='off' maxLength="100"
                                                placeholder="Enter Association Name"
                                            />
                                            <ErrorMessage name="nameofserviceassociation" className="text-error" component="div" />
                                        </HERBUI.Col>
                                        <HERBUI.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className="mb-3">
                                            <label className="mb-2"> Name of the Department:<span className="text-danger">*</span> </label>
                                           
                                            <Select
                         isOptionDisabled={(option) => option.isdisabled}
                         options={departmentlist} isSearchable={true} isClearable={true}
                         getOptionValue={option => option.sdeptcode}
                      
                          getOptionLabel={option => option.sdeptcode + "-" + option.description }
                         name="nameofdepartment"
                         selectedOption={formik.values?.nameofdepartment}
                         value={departmentlist?.find(it => it?.sdeptcode === formik.values?.nameofdepartment) || null}
                         onChange={(selectedOption) => {
                             if (selectedOption !== null) {
                              
                                 formik.setFieldValue('nameofdepartment', selectedOption.sdeptcode)
                                
                             }
                             else {
                                 formik.setFieldValue('nameofdepartment', "")
                             }
                         }}
                         required={true} />
                                          
                                            <ErrorMessage name="nameofdepartment" className="text-error" component="div" />
                                        </HERBUI.Col>
                                        <HERBUI.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className="mb-3">
                                            <label className="mb-2"> Total no. of Employees in the Department:<span className="text-danger">*</span> </label>
                                            <Field type="text" name="totalnoofempleindepartme" className="form-control" autoComplete='off'
                                                placeholder="Enter Total no.of Employees" onKeyPress={allowNumbersOnly} onChange={(e) => handleEmploytotal(e)} maxLength="10"
                                            />
                                            <ErrorMessage name="totalnoofempleindepartme" className="text-error" component="div" />
                                        </HERBUI.Col>
                                        <HERBUI.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className="mb-3">
                                            <label className="mb-2">No. of Enrolled Members in the Association:<span className="text-danger">*</span> </label>
                                            <Field type="text" name="noofempenrolledinasso" className="form-control" autoComplete='off'
                                                placeholder="Enter  No.of Enrolled Members" onKeyPress={allowNumbersOnly} onBlur={(e) => handleenrollmemauto(e)} maxLength="10" />
                                            <ErrorMessage name="noofempenrolledinasso" className="text-error" component="div" />
                                        </HERBUI.Col>
                                        <HERBUI.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className="mb-3">
                                            <label className="mb-2"> Percentage of Members Enrolled:<span className="text-danger">*</span> </label>
                                            <Field type="text" name="percenofempenrolled" className="form-control" autoComplete='off' disabled={true}
                                            />
                                            <ErrorMessage name="percenofempenrolled" className="text-error" component="div" />
                                        </HERBUI.Col>
                                        <HERBUI.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className="mb-3">
                                            <label className="mb-2"> Bank Account Number:<span className="text-danger">*</span> </label>
                                            <Field type="text" name="bankaccountnumber" className="form-control" placeholder="Enter Bank Account"
                                            autoComplete='off' maxLength="17" onKeyPress={allowNumbersOnly}
                                            />
                                            <ErrorMessage name="bankaccountnumber" className="text-error" component="div" />
                                        </HERBUI.Col>
                                        <HERBUI.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className="mb-3">
                                            <label className="mb-2"> IFSC Code:<span className="text-danger">*</span> </label>
                                            <Field type="text" name="ifsccode" className="form-control" placeholder="Enter  IFSC Code"
                                            autoComplete='off' maxLength="11"
                                            />
                                            <ErrorMessage name="ifsccode" className="text-error" component="div" />
                                        </HERBUI.Col>
                                        <HERBUI.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className="mb-3">
                                                <label className="mb-2"> Upload Registration Certificate:<span className="text-danger">*</span></label>
                                                <input type="file" id="rigistrationfile" name="rigistrationfile" maxLength="15" className="form-control" onChange={(event) => fileupload(event, 'rigistrationfile', formik)} />
                                                <ErrorMessage name="rigistrationfile" component="div" className="text-error" />
                                            </HERBUI.Col>
                                        
                                            <HERBUI.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className="mb-3">
                                                <label className="mb-2"> Upload by-laws File:<span className="text-danger">*</span></label>
                                                <input type="file" id="bylawsfileupload" name="bylawsfileupload" maxLength="15" className="form-control" onChange={(event) => fileupload(event, 'bylawsfileupload', formik)} />
                                                <ErrorMessage name="bylawsfileupload" component="div" className="text-error" />
                                            </HERBUI.Col>
                            
                                        
                                            <HERBUI.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className="mb-3">
                                                <label className="mb-2"> Upload  Audited Report File:<span className="text-danger">*</span></label>
                                                <input type="file" id="annualauditedfileupload" name="annualauditedfileupload" maxLength="15" className="form-control" onChange={(event) => fileupload(event, 'annualauditedfileupload', formik)} />
                                                <ErrorMessage name="annualauditedfileupload" component="div" className="text-error" />
                                            </HERBUI.Col>
                                            <HERBUI.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className="mb-3">
                                                <label className="mb-2">Upload Appointment of Election Officer File:<span className="text-danger">*</span></label>
                                                <input type="file" id="appointmentofficerfile" name="appointmentofficerfile" maxLength="15" className="form-control"
                                                    onChange={(event) => fileupload(event, 'appointmentofficerfile', formik)} />
                                                <ErrorMessage name="appointmentofficerfile" component="div" className="text-error" />
                                            </HERBUI.Col>
                                        
                                            <HERBUI.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className="mb-3">
                                                <label className="mb-2">Upload Election Declaration File:<span className="text-danger">*</span></label>
                                                <input type="file" id="electiondeclarationfileupload" name="electiondeclarationfileupload" maxLength="15" className="form-control"
                                                    onChange={(event) => fileupload(event, 'electiondeclarationfileupload', formik)} />
                                                <ErrorMessage name="electiondeclarationfileupload" component="div" className="text-error" />
                                            </HERBUI.Col>
                                      
                                            <HERBUI.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className="mb-3">
                                                <label className="mb-2"> Upload List of Office Bearers File:<span className="text-danger">*</span></label>
                                                <input type="file" id="listofofficebeareresfileupload" name="listofofficebeareresfileupload" maxLength="15" className="form-control"
                                                    onChange={(event) => fileupload(event, 'listofofficebeareresfileupload', formik)} />
                                                <ErrorMessage name="listofofficebeareresfileupload" component="div" className="text-error" />
                                            </HERBUI.Col>
                                            <HERBUI.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className="mb-3">
                                                <label className="mb-2"> Upload Election Notification File:<span className="text-danger">*</span></label>
                                                <input type="file" id="electionnotificationfile" name="electionnotificationfile" maxLength="15" className="form-control"
                                                    onChange={(event) => fileupload(event, 'electionnotificationfile', formik)} />
                                                <ErrorMessage name="electionnotificationfile" component="div" className="text-error" />
                                            </HERBUI.Col>
                                        

                                        <HERBUI.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className="mb-3">
                                            <label className="mb-2"> If already registered, Registered G.O. No and Date:<span className="text-danger">*</span> </label>
                                            <Field className="pt-3" type="radio" name="alreadyregisterthengodate" value="yes" /><b className="px-1 pe-4">Yes</b>
                                            <Field className="pt-3" type="radio" name="alreadyregisterthengodate" value="no" /><b className="px-1 pe-4">No</b>
                                            <ErrorMessage name="alreadyregisterthengodate" className="text-error" component="div" />
                                        </HERBUI.Col>
                                        {
                                            formik.values.alreadyregisterthengodate === 'yes' &&
                                            <>
                                                <HERBUI.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className="mb-3">
                                                    <label className="mb-2"> GO Type:<span className="text-danger">*</span> </label>
                                                    <Field component="select" name="gotype" className="form-control" autoComplete='off'
                                                        onChange={handledotype}>
                                                        <option value="" >Select</option>
                                                        <option value="ms">MS</option>
                                                        <option value="rt">RT</option>
                                                    </Field>
                                                    <ErrorMessage name="gotype" className="text-error" component="div" />
                                                </HERBUI.Col>
                                                <HERBUI.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className="mb-3">
                                                    <label className="mb-2"> GO Number:<span className="text-danger">*</span> </label>
                                                    <Field type="text" name="gonumber" className="form-control" autoComplete='off' onKeyPress={allowNumbersOnly}  maxLength="10"/>
                                                    <ErrorMessage name="gonumber" className="text-error" component="div" />
                                                </HERBUI.Col>
                                                <HERBUI.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className="mb-3">
                                                    <label className="mb-4 pb-1"> GO Date :<span className="text-danger">*</span> </label>
                                                    <DatePicker placeholderText="DD/MM/YYYY" name="godate" className="form-control" dateFormat="dd/MM/yyyy"
                                                        showYearDropdown
                                                        showMonthDropdown maxDate={new Date()}
                                                        dropdownMode='select' selected={formik.values.godate}
                                                        onChange={(e) => handlegodate(e)} autoComplete='off' />
                                                    <ErrorMessage name="godate" className="text-error" component="div" />
                                                </HERBUI.Col>
                                            </>
                                        }
                                        <HERBUI.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className="mb-3">
                                            <label className="mb-2"> Official Address of service association for correspondence:<span className="text-danger">*</span> </label>
                                            <Field type="text" name="officialaddressofserviceass" className="form-control" autoComplete='off'
                                                placeholder="Enter Address."  maxLength="100"/>
                                            <ErrorMessage name="officialaddressofserviceass" className="text-error" component="div" />
                                        </HERBUI.Col>
                                        <HERBUI.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className="mb-3"><br />
                                            <label className="mb-2"> Alternative Mobile Number for Contact:<span className="text-danger">*</span> </label>
                                            <Field type="text" name="officialmobilenumber" className="form-control" autoComplete='off' maxLength="10"
                                                placeholder="Enter mobile number" onKeyPress={allowNumbersOnly} />
                                            <ErrorMessage name="officialmobilenumber" className="text-error" component="div" />
                                        </HERBUI.Col>

                                        <HERBUI.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className="mb-3">
                                        <label className="mt-4 mb-2">Employee ID (CFMS ID) <b className="text-danger">*</b></label>
                                    <Field type="text" name="cfmsid" className="form-control" autoComplete="off" 
                                     maxLength="8" onBlur={getDetails} onKeyPress={allowNumbersOnly} placeholder="Enter CFMS ID"/>
                                    <ErrorMessage name="cfmsid" className="text-error" component="div" />
                                </HERBUI.Col>
                                <HERBUI.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className="mb-3">
                                <label className="mt-4">Employee Name<b className="text-danger">*</b></label>
                                    <Field type="text" name="username" className="form-control" autoComplete="off" disabled={true} />
                                    <ErrorMessage name="username" className="text-error" component="div" />
                                </HERBUI.Col>
                                <HERBUI.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className="mb-3">
                                <label className="mt-4">Mobile Number In CFMS<b className="text-danger">*</b></label>
                                    <Field type="text" name="mobilenumber" className="form-control" autoComplete="off" disabled={true} />
                                    <ErrorMessage name="mobilenumber" className="text-error" component="div" />
                                </HERBUI.Col>
                               
                               
                                {otpflag &&<>
                                <HERBUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3">
                                <label className="mt-4">OTP :<b className="text-danger">*</b></label>
                                                       
                                                        <Field type="text" placeholder="Enter OTP ----" name="enteredOtp"  className="form-control" maxLength="6" 
                                                           onKeyPress={allowNumbersOnly} 
                                                         />
                                                        </HERBUI.Col>
                                                        
                                                     </> 
                                                    
                                }
                                        <HERBUI.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className="mt-4"><br />
                                                         <div className="d-grid gap-2 mb-5">
                                                             <HERBUI.Button variant="primary" type="submit" className="btn_primary">
                                                              {name}
                                                             </HERBUI.Button>
                                                         </div>
                                                     </HERBUI.Col>

                                    </HERBUI.Row>
                             
                        </form>
                    </FormikProvider>
                </HERBUI.Container>
            </div>
        </>
    )

}
export default ServiceAssociationMain;